var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.33337C13.7013 1.33337 14 1.63204 14 2.00004V14C14 14.368 13.7013 14.6667 13.3333 14.6667H4C3.632 14.6667 3.33333 14.368 3.33333 14V12.6667H2V11.3334H3.33333V10H2V8.66671H3.33333V7.33337H2V6.00004H3.33333V4.66671H2V3.33337H3.33333V2.00004C3.33333 1.63204 3.632 1.33337 4 1.33337H13.3333ZM12.6667 2.66671H4.66667V13.3334H12.6667V2.66671ZM9.33333 5.33337V7.33337H11.3333V8.66671H9.33267L9.33333 10.6667H8L7.99933 8.66671H6V7.33337H8V5.33337H9.33333Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsp);
export default __webpack_public_path__ + "static/media/esp.bfbfb7a6985c2b42ff4bbde9fe3ee0bc.svg";
export { ForwardRef as ReactComponent };